import { render } from "./addAdvertisement.vue?vue&type=template&id=ac6959c6"
import script from "./addAdvertisement.vue?vue&type=script&lang=js"
export * from "./addAdvertisement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__